var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n        dgdfchcfghjvfgjcfh\n    ")]),_vm._v(" "),_vm._l((_vm.list),function(item,key){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(key<_vm.num),expression:"key<num"}]},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),_vm._v(" "),_c('span',{on:{"click":_vm.showMore}},[_vm._v(_vm._s(_vm.txt))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e52c26d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/test.vue
// module id = null
// module chunks = 